import type { PluginOption } from 'vite';
import { outdent } from 'outdent';

export function patchAstroInlineScripts(): PluginOption {
  return {
    name: 'patch-astro-inline-scripts',
    transform(code, id) {
      const [_filename, rawQuery] = id.split(`?`, 2);
      const query = Object.fromEntries(new URLSearchParams(rawQuery).entries());

      if (
        query.astro == null ||
        query.type !== 'script' ||
        query['lang.ts'] == null ||
        code === ''
      ) {
        return null;
      }

      return outdent`
        import 'astro:scripts/page.js';

        ${code}
      `;
    },
  };
}
